import { User, SystemSettings, AnalyticsData } from '@/types/admin';

export const mockUsers: User[] = [
  {
    id: '1',
    name: 'John Doe',
    email: 'john@agency.com',
    role: 'admin',
    status: 'active',
    createdAt: new Date('2024-01-15'),
    lastActive: new Date(),
  },
  {
    id: '2',
    name: 'Sarah Johnson',
    email: 'sarah@agency.com',
    role: 'employee',
    status: 'active',
    createdAt: new Date('2024-02-01'),
    lastActive: new Date(Date.now() - 2 * 60 * 60 * 1000),
  },
  {
    id: '3',
    name: 'Mike Chen',
    email: 'mike@agency.com',
    role: 'employee',
    status: 'active',
    createdAt: new Date('2024-02-15'),
    lastActive: new Date(Date.now() - 24 * 60 * 60 * 1000),
  },
  {
    id: '4',
    name: 'Emily Davis',
    email: 'emily@agency.com',
    role: 'employee',
    status: 'inactive',
    createdAt: new Date('2024-03-01'),
    lastActive: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
  },
];

export const mockSystemSettings: SystemSettings = {
  companyName: 'Agency HQ',
  welcomeMessage: 'Welcome to Agency HQ Console. How can I help you today?',
  maxSessionsPerUser: 50,
  allowImageUploads: true,
  allowFileUploads: true,
  retentionDays: 90,
  apiRateLimit: 100,
};

export const mockAnalytics: AnalyticsData = {
  totalSessions: 1247,
  totalMessages: 8934,
  activeUsers: 12,
  commandsUsed: 4521,
  avgSessionDuration: '12m 34s',
  topCommands: [
    { name: '/ic', count: 1823 },
    { name: '/social', count: 1245 },
    { name: '/analyze', count: 876 },
    { name: '/askalden', count: 654 },
    { name: '/strategy', count: 432 },
  ],
  dailyActivity: [
    { date: 'Mon', sessions: 145, messages: 892 },
    { date: 'Tue', sessions: 178, messages: 1123 },
    { date: 'Wed', sessions: 156, messages: 1045 },
    { date: 'Thu', sessions: 189, messages: 1256 },
    { date: 'Fri', sessions: 167, messages: 1089 },
    { date: 'Sat', sessions: 89, messages: 534 },
    { date: 'Sun', sessions: 67, messages: 412 },
  ],
};
